module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics_1"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("流量分析")]), _vm._v(" "), _c('span', {
    staticClass: "dateSpan"
  }, [_vm._v("（" + _vm._s(_vm.dateTime) + "）")]), _vm._v(" "), _c('div', {
    staticClass: "labArea"
  }, [_c('span', {
    staticClass: "labSelectText"
  }, [_vm._v("数据库：")]), _vm._v(" "), _c('el-select', {
    staticClass: "labSelect",
    attrs: {
      "size": "small",
      "placeholder": "请选择数据库"
    },
    on: {
      "change": _vm.labChange
    },
    model: {
      value: (_vm.labCode),
      callback: function($$v) {
        _vm.labCode = $$v
      },
      expression: "labCode"
    }
  }, _vm._l((_vm.lbSet), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_vm._m(0), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.testData), function(term) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(term.tName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.pv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.uv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.pTime))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', {
    staticClass: "ttText"
  }, [_vm._v("流量分析图")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "timeArea"
  }, [_c('span', [_vm._v("时间域：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.mapDatFor
    },
    model: {
      value: (_vm.timeVal),
      callback: function($$v) {
        _vm.timeVal = $$v
      },
      expression: "timeVal"
    }
  }, _vm._l((_vm.timeSelect), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1)])]), _vm._v(" "), [_c('v-chart', {
    staticStyle: {
      "height": "360px",
      "width": "100%"
    },
    attrs: {
      "options": _vm.line
    }
  })]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', {
    staticClass: "ttText"
  }, [_vm._v("流量分析表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tHead"
  }, [_c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("浏览次数（PV）")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("独立访客（UV）")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("IP访问量")]), _vm._v(" "), _c('td', [_vm._v("播放时长")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-417831d7"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/flowAnalysis.vue
// module id = 1467
// module chunks = 1